import React from "react";

export default function UploadProgramDoc({
  fileInputRef,
  data,
  setData,
  label,
}) {
  const handleProgramDocInput = async (event) => {
    const { files } = event.target;
    const file = files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setData((p) => ({
          ...p,
          [label]: reader.result.split(",")[1],
          [`${label}Name`]: file.name,
          [`${label}type`]: file.type,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const isImage = data[`${label}type`]?.startsWith("image/") && data[label];
  const isPdf = data[`${label}type`] === "application/pdf" && data[label];

  return (
    <div>
      {data[label] ? (
        <div className="d-flex mt-2 position-relative">
          {isImage && (
            <img
              src={`data:${data[`${label}type`]};base64,${data[label]}`}
              alt="Uploaded"
              className=""
              style={{ maxWidth: "90%", maxHeight: "130px" }}
            />
          )}

          {isPdf && (
            <div
              className="pdf-preview-container"
              style={{
                width: "90%",
                height: "130px",
                border: "1px solid #dee2e6",
                borderRadius: "4px",
                overflow: "hidden",
              }}
            >
              <div
                className="pdf-header"
                style={{
                  background: "#f8f9fa",
                  padding: "8px 12px",
                  borderBottom: "1px solid #dee2e6",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="d-flex align-items-center">
                  <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
                  <span className="text-muted small">
                    {data[`${label}Name`]}
                  </span>
                </div>
                <a
                  href={`data:${data[`${label}type`]};base64,${data[label]}`}
                  download={data[`${label}Name`]}
                  className="btn btn-sm btn-outline-primary"
                  style={{ fontSize: "12px", padding: "2px 8px" }}
                >
                  <i className="bi bi-download me-1"></i>
                  Download
                </a>
              </div>
              <embed
                src={`data:${data[`${label}type`]};base64,${data[label]}`}
                type="application/pdf"
                width="100%"
                height="calc(100% - 40px)"
                style={{ border: "none" }}
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "block";
                }}
              />
              <div
                className="pdf-error-fallback"
                style={{
                  display: "none",
                  height: "calc(100% - 40px)",
                  background: "#f8f9fa",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#6c757d",
                }}
              >
                <i
                  className="bi bi-file-earmark-pdf text-danger"
                  style={{ fontSize: "2rem", marginBottom: "8px" }}
                ></i>
                <p className="mb-1 small">PDF Preview not available</p>
                <a
                  href={`data:${data[`${label}type`]};base64,${data[label]}`}
                  download={data[`${label}Name`]}
                  className="btn btn-sm btn-outline-primary"
                  style={{ fontSize: "12px" }}
                >
                  <i className="bi bi-download me-1"></i>
                  Download to view
                </a>
              </div>
            </div>
          )}

          <button
            className="btn btn-link btn-cross"
            style={{
              position: "absolute",
              right: "35px",
              top: "-13px",
            }}
            onClick={() => {
              setData((p) => ({
                ...p,
                [label]: "",
                [`${label}Name`]: "",
                [`${label}type`]: "",
              }));
            }}
          >
            <i className="bi bi-x-circle-fill text-danger text2"></i>
          </button>
        </div>
      ) : (
        <>
          <div className="text1-4 text-dark1 d-flex align-items-center ms-2 mt-2">
            <label
              htmlFor={`importInput_${label}`}
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex align-items-center">
                <i className="bi bi-cloud-plus text-dark1 text1-6 d-flex align-items-center justify-content-center me-2"></i>
                <span className="text1-3">Upload</span>
              </div>
            </label>

            <input
              id={`importInput_${label}`}
              type="file"
              className="d-none"
              ref={fileInputRef}
              accept="image/jpeg,image/jpg,image/png,application/pdf"
              onChange={handleProgramDocInput}
            />
          </div>
        </>
      )}
    </div>
  );
}
